export default {
    title: 'Innovation projects featuring outdated trends',
    text: 'The following innovation projects contain macro-trends that are no longer part of the current Trendone trend universe:',
    recommendation: 'We recommend to activate the new macro-trends and to add them to affected work spaces. Affected innovation projects and macro-trends are marked with a red info sign. You can read about all changes in the product update section.'
}
